import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { mergeObjects } from '@utils/functions';

export async function initI18nLocale(
  translations: { en: any },
  // returnUndefined: boolean = false,
  translationURL?: string,
) {
  let mergedTranslations = { ...translations.en };
  // Merge if app is in embedded mode and translationURL is provided
  if (translationURL) {
    try {
      const translationURLResponse = await fetch(translationURL);
      if (translationURLResponse.ok) {
        const remoteTranslations = await translationURLResponse.json();
        mergedTranslations = mergeObjects(
          translations.en,
          remoteTranslations,
          true,
        );
      }
    } catch (e) {
      // Error fetching translations from host store's translationURL
      console.error(
        "Error fetching translations from host store's translation URL",
        e,
      );
    }
  }

  return i18n.use(initReactI18next).init({
    resources: { en: { translation: mergedTranslations } },
    lng: 'en',
    fallbackLng: 'en',
    debug: true,
    interpolation: {
      escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    },
    // parseMissingKeyHandler: key => {
    //   return returnUndefined ? undefined : key;
    // },
  });
}
